import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateRessourceCategoryRequest, IRessourceCategory } from '../models/ressource-category';

@Injectable({
  providedIn: 'root'
})
export class RessourceCategoryService {

  constructor(private http: HttpClient) { }

  searchRessourceCategories(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IRessourceCategory[]>>(
      `${environment.baseUrl}/v1/RessourceCategory/searchRessourceCategories`,
      {pageSize: 999999, pageNumber: 0}
    )
  }

  getRessourceCategory(id: string){
    return this.http.get<string>(
      `${environment.baseUrl}/v1/RessourceCategory/getRessourceCategory/${id}`
    )
  }

  createRessourceCategory(request: ICreateRessourceCategoryRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/RessourceCategory/createRessourceCategory`,
      request
    )
  }

  updateRessourceCategory(request: IRessourceCategory){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/RessourceCategory/updateRessourceCategory/${request.id}`,
      request
    )
  }

  deleteRessourceCategory(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/RessourceCategory/deleteRessourceCategory/${id}`
    )
  }
}
